import { defineMessages } from 'react-intl';

export const messages: {
	foundIn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	similar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	related: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionedIn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	relatedPages: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	seeAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	foundIn: {
		id: 'search-page.linked-results.found-in',
		defaultMessage: 'Found in',
		description: 'Label to indicate where the linked result was found',
	},
	similar: {
		id: 'search-page.linked-results.similar',
		defaultMessage: '{count} similar',
		description: 'Label for similar linked results',
	},
	related: {
		id: 'search-page.linked-results.related',
		defaultMessage: 'Related links',
		description: 'Label for related linked results',
	},
	mentionedIn: {
		id: 'search-page.linked-results.mentioned-in',
		defaultMessage: 'Mentioned in',
		description:
			'Label for mentioned-by linked results showing where a document has been mentioned',
	},
	relatedPages: {
		id: 'search-page.linked-results.related-pages',
		defaultMessage: 'Related pages',
		description:
			'Label for related pages (child linked results under Confluence directory or empty file)',
	},
	showMore: {
		id: 'search-page.linked-results.show-more',
		defaultMessage: 'Show {count} more',
		description: 'Button text to show more linked results',
	},
	seeAll: {
		id: 'search-page.linked-results.see-all',
		defaultMessage: 'See all',
		description: 'Button text to see all linked results on the full page',
	},
	externalLink: {
		id: 'search-page.linked-results.external-link',
		defaultMessage: 'External link',
		description: 'Label for external link icon',
	},
});
